<template>
  <svg
    width="82"
    height="44"
    viewBox="0 0 82 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 1C30 0.447715 30.4477 0 31 0H81C81.5523 0 82 0.447715 82 1V11C82 11.5523 81.5523 12 81 12H31C30.4477 12 30 11.5523 30 11V1Z"
    />
    <path
      d="M30 17C30 16.4477 30.4477 16 31 16H81C81.5523 16 82 16.4477 82 17V27C82 27.5523 81.5523 28 81 28H31C30.4477 28 30 27.5523 30 27V17Z"
    />
    <path
      d="M30 33C30 32.4477 30.4477 32 31 32H81C81.5523 32 82 32.4477 82 33V43C82 43.5523 81.5523 44 81 44H31C30.4477 44 30 43.5523 30 43V33Z"
    />
    <path
      d="M0 0.999999C0 0.447714 0.447715 0 1 0H25C25.5523 0 26 0.447715 26 1V43C26 43.5523 25.5523 44 25 44H1C0.447716 44 0 43.5523 0 43V0.999999Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ActiveSidebarLayoutIcon",
};
</script>
